import { Switch, SwitchProps } from '@mui/material';

export interface StatusSwitchProps extends Omit<SwitchProps, 'size'> {
  size?: 'small' | 'medium';
}

/**
 * Permission status switch: green track when enabled, red when disabled.
 * Matches the theme's compact Switch (white thumb, solid tracks) and overrides
 * the primary on-track color with success/error.
 *
 * Uses `&&` so these track colors beat the theme's
 * `MuiSwitch-colorPrimary.Mui-checked` styleOverride (`#03a6e2`).
 */
export function StatusSwitch(props: StatusSwitchProps) {
  const { sx, size, disabled, ...rest } = props;

  return (
    <Switch
      {...rest}
      size={size}
      disabled={disabled}
      sx={[
        {
          // Double root specificity to outrank theme switchBase colorPrimary rules.
          '&& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: 'success.light',
          },
          '&& .MuiSwitch-track': {
            backgroundColor: 'error.main',
          },
          '& .MuiSwitch-switchBase': {
            color: '#fff',
            '&.Mui-checked': {
              color: '#fff',
            },
          },
          opacity: disabled ? 0.5 : undefined,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
}
